import type { GpwCompany } from "./types";

export function normalizeIsin(value: unknown) {
  return typeof value === "string" ? value.trim().toUpperCase() : "";
}

export function isIsin(value: unknown) {
  const normalized = normalizeIsin(value);
  if (!/^[A-Z]{2}[A-Z0-9]{9}[0-9]$/.test(normalized)) return false;
  const digits = [...normalized]
    .map((character) => /[0-9]/.test(character) ? character : String(character.charCodeAt(0) - 55))
    .join("");
  let sum = 0;
  let double = false;
  for (let index = digits.length - 1; index >= 0; index -= 1) {
    let digit = Number(digits[index]);
    if (double) {
      digit *= 2;
      if (digit > 9) digit -= 9;
    }
    sum += digit;
    double = !double;
  }
  return sum % 10 === 0;
}

export function uniqueCompanyByIsin<T extends GpwCompany>(
  companies: T[],
  isin: unknown,
): T | undefined {
  if (!isIsin(isin)) return undefined;
  const matches = companies.filter((company) => normalizeIsin(company.isin) === normalizeIsin(isin));
  return matches.length === 1 ? matches[0] : undefined;
}
